/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Map_SectionInputs */

const fr_settings_map_section = /** @type {(inputs: Settings_Map_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte`)
};

const en_settings_map_section = /** @type {(inputs: Settings_Map_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map`)
};

/**
* | output |
* | --- |
* | "Map" |
*
* @param {Settings_Map_SectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_map_section = /** @type {((inputs?: Settings_Map_SectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Map_SectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_map_section(inputs)
	return en_settings_map_section(inputs)
});